import { useMemo } from "react";
import QRCode from "qrcode";

// Desenha o QR a partir do texto que o bot publica (o painel nunca recebe a
// imagem pronta). qrcode.create é síncrono e puro, funciona no jsdom.

const QUIET_ZONE = 2;

/** Caminho SVG com um quadrado por módulo escuro. Exportado para teste. */
export function qrPath(text: string): { size: number; d: string } {
  const { modules } = QRCode.create(text, { errorCorrectionLevel: "M" });
  const parts: string[] = [];
  for (let row = 0; row < modules.size; row += 1) {
    for (let col = 0; col < modules.size; col += 1) {
      if (modules.data[row * modules.size + col]) {
        parts.push(`M${col + QUIET_ZONE} ${row + QUIET_ZONE}h1v1h-1z`);
      }
    }
  }
  return { size: modules.size + QUIET_ZONE * 2, d: parts.join("") };
}

interface QrCodeSvgProps {
  value: string;
  label: string;
}

export function QrCodeSvg({ value, label }: QrCodeSvgProps): JSX.Element {
  const { size, d } = useMemo(() => qrPath(value), [value]);
  return (
    <svg
      role="img"
      aria-label={label}
      viewBox={`0 0 ${size} ${size}`}
      className="h-56 w-56 rounded-lg bg-white p-1"
      shapeRendering="crispEdges"
    >
      <path d={d} fill="#0a0a0a" />
    </svg>
  );
}
